export enum PROMOTIONS {
  Referral = "Referral",
  Partner = "Partner",
  Other = "Other",
}
